import React, { memo } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "@iconify/react";
import styles from "./Sidebar.module.css";
import Logo from "../Logo";
import { useSelector } from "react-redux";

const Sidebar = memo(({ offsetTop = 0 }) => {
  const websiteSetting = useSelector((state) => state.user.websiteSetting);
  const settings = Array.isArray(websiteSetting)
    ? websiteSetting[0]
    : websiteSetting?.data?.[0] || {};
  const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(
    /\/$/,
    "",
  );

  const resolveIconSrc = (path) => {
    if (!path) return "";
    if (/^https?:/i.test(path)) return path;
    return `${apiBaseUrl}${path.startsWith("/") ? "" : "/"}${path}`;
  };

  const renderSidebarIcon = (customPath, fallbackIcon, alt) => {
    const src = resolveIconSrc(customPath);
    if (src) {
      return <img src={src} alt={alt} className={styles.iconImage} />;
    }
    return <Icon icon={fallbackIcon} className={styles.icon} />;
  };

  const menuItems = [
    {
      path: "/slot",
      title: "สล๊อต",
      icon: "mdi:slot-machine",
      customIcon: settings?.sidebarSlotIconUrl,
    },
    {
      path: "/livecasino",
      title: "คาสิโน",
      icon: "cil:casino",
      customIcon: settings?.sidebarCasinoIconUrl,
    },
    {
      path: "/sportbook",
      title: "กีฬา",
      icon: "emojione-monotone:soccer-ball",
      customIcon: settings?.sidebarSportIconUrl,
    },
    {
      path: "/card",
      title: "ยิงปลา",
      icon: "game-icons:spearfishing",
      customIcon: settings?.sidebarFishIconUrl,
    },
  ];

  const desktopOffsetStyle =
    offsetTop > 0
      ? {
          top: `${offsetTop}px`,
        }
      : undefined;

  return (
    <aside className={styles.sidebar} style={desktopOffsetStyle}>
      <div className={styles.mobileLogo}>
        <Logo />
      </div>
      <nav className={styles.nav}>
        <ul className={styles.menuList}>
          {menuItems.map((item) => (
            <li key={item.path} className={styles.menuItem}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `${styles.menuLink} ${isActive ? styles.active : ""} ${
                    item.customIcon ? styles.menuLinkImage : ""
                  }`
                }
                title={item.title}
              >
                {renderSidebarIcon(item.customIcon, item.icon, item.title)}
                <span className={styles.title}>{item.title}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
});

Sidebar.displayName = "Sidebar";

export default Sidebar;
